// extracted by mini-css-extract-plugin
export default {"block":"_332c31d1","inline":"_9aa71951","wrapper":"_a139b1cb","tooltipWrapper":"_f4aa7c5e","closeIcon":"_5a631f65","questionWrapper":"_fe669405","questionIcon":"_c325417d"};